import React from 'react'
import styled from 'styled-components'
import { color } from '@configs/utilities'
import { Link } from 'gatsby-plugin-react-intl'
import AccordionMobileNavbar from '@components/ui/accordions/AccordionMobileNavbar'
import NavbarButtons from './NavbarButtons'
import { useLocation } from '@reach/router'

const NavItemsMobile = ({ intl, data }) => {
  const location = useLocation().pathname.split('/').pop()

  return (
    <NavItemsMobileWrapper>
      <MobileLinksWrapper>
        {data.map((item, index) => {
          return (
            <div key={index}>
              {!item.node.submenu ? (
                <NavbarItem className="mainLinks">
                  <Link to={item.node.path} activeClassName="activeNavbarLink">
                    {intl.formatMessage({ id: item.node.text })}
                  </Link>
                </NavbarItem>
              ) : (
                <NavbarItem>
                  <AccordionMobileNavbar
                    id={index}
                    head={intl.formatMessage({ id: item.node.text })}
                    partiallyActive
                    activeClassName={
                      item.node.submenu.some((item) => {
                        return item.path.includes(location)
                      }) && location !== ''
                        ? 'activeNavbarLink'
                        : ''
                    }
                    text={
                      <AccordionMobileSubmenu>
                        {item.node.submenu.map((item, index) => {
                          return (
                            <AccordionSubmenuLinksWrapper key={index}>
                              {item.path.includes('https') ? (
                                <a href={item.path} target="_self" rel="noopener noreferrer">
                                  {intl.formatMessage({ id: item.text })}
                                </a>
                              ) : (
                                <Link to={item.path} partiallyActive activeClassName="activeNavbarLink">
                                  {intl.formatMessage({ id: item.text })}
                                </Link>
                              )}
                            </AccordionSubmenuLinksWrapper>
                          )
                        })}
                      </AccordionMobileSubmenu>
                    }
                  />
                </NavbarItem>
              )}
            </div>
          )
        })}
      </MobileLinksWrapper>
      <MobileButtonsWrapper>
        <NavbarButtons />
      </MobileButtonsWrapper>
    </NavItemsMobileWrapper>
  )
}

export default NavItemsMobile

const NavItemsMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  font-weight: 300;

  /* --------------------------  ACTIVE --------------------------- */
  .activeNavbarLink {
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 3px;
      height: 40px;
      top: 5px;
      left: -15px;
      background-color: ${color.blue};
    }
  }
`

const NavbarItem = styled.div`
  position: relative;

  border-top: 1px solid ${color.grayLight};
  padding: 15px 0;
`

const MobileLinksWrapper = styled.div`
  a {
    color: ${color.font};
  }
`

const AccordionMobileSubmenu = styled.div`
  font-size: 14px;
  padding-bottom: 10px;
`

const AccordionSubmenuLinksWrapper = styled.div`
  display: flex;
  padding-left: 5px;

  a {
    margin: 10px 0;
    font-size: 15px;
    font-weight: 300;
  }

  .activeNavbarLink {
    color: ${color.blue};
  }
`

const MobileButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  a {
    width: 100%;
  }
`
